import React, { useState } from "react";
import { Button, Col, Container, Row, Image } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { QRCode } from "react-qr-svg";
//var QRCodeNew = require("qrcode.react");

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../store/validation/is-Empty";

const Referrealcodeview = (props) => {
  //state
  const [side, setSide] = useState(1);
  const [onBoardingDataId, setOnBoardingDataId] = useState(
    props.onboarding && props.onboarding._id
  );
  const handleSideChange = (e) => setSide(e);
  const printQrCodeAction = () => {
    const printableElements = document.getElementById("printme").innerHTML;
    const orderHtml =
      "<html><head><title></title></head><body>" +
      printableElements +
      "</body></html>";
    const oldPage = document.body.innerHTML;
    document.body.innerHTML = orderHtml;
    window.print();
    // window.location.reload();
    document.body.innerHTML = oldPage;
  };
  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <Row>
              <Col md={12}>
                <div className="d-flex align-items-center justify-content-center pb-4">
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      side === 1 ? "active" : ""
                    }`}
                    onClick={() => handleSideChange(1)}
                  >
                    Front
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 text-grayLink f12-500 ${
                      side === 2 ? "active" : ""
                    }`}
                    onClick={() => handleSideChange(2)}
                  >
                    Back
                  </Button>
                </div>
                {side === 1 && (
                  <React.Fragment>
                    <div id="printme" className="d-flex justify-content-center">
                      <div className="QRMain">
                        <div className="QRInner p-4">
                          <div className="pt-4">
                            <Image
                              fluid
                              src={require("../../../assets/images/UserManagement/fullLogo.svg")}
                              alt="Logo"
                            />
                          </div>
                          <div className="print-14-400-h my-2">
                            Accepted Here
                          </div>
                          <div>
                            <Image
                              fluid
                              src={
                                props.onboarding && props.onboarding.logo_url
                              }
                              alt="Logo"
                              className="w-25"
                            />
                          </div>
                          <div className="qrPript">
                            <QRCode
                              bgColor="#FFFFFF"
                              fgColor="#000000"
                              level="H"
                              value={
                                props.auth?.user?.VendorUser?.shareLink
                                  ?.userShortLink || " "
                              }
                            />
                          </div>
                          <div className="print-12-400-r text-uppercase">
                            <span className="print-border-bottom">
                              {props.onboarding &&
                                props.onboarding.restaurant_name}
                            </span>
                          </div>
                          <div className="print-12-400-r text-uppercase">
                            <span className="print-border-bottom print-hide-text">
                              {props.onboarding &&
                                props.onboarding.restaurant_name}
                            </span>
                          </div>
                          <div className="print-12-400-h">
                            Scan via Amealio App
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="py-4 d-flex justify-content-center align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 btn150px"
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5 btn150px"
                        onClick={printQrCodeAction}
                      >
                        Print
                      </Button>
                    </div>
                  </React.Fragment>
                )}
                {side === 2 && (
                  <React.Fragment>
                    <div id="printme" className="d-flex justify-content-center">
                      <div className="QRMain">
                        <div className="QRInner p-4">
                          <div className="pt-4">
                            <Image
                              fluid
                              src={require("../../../assets/images/UserManagement/fullLogo.svg")}
                              alt="Logo"
                            />
                          </div>
                          <div className="print-14-400-h my-2">
                            Accepted Here
                          </div>
                          <div>
                            <Image
                              fluid
                              src={
                                props.onboarding && props.onboarding.logo_url
                              }
                              alt="Logo"
                              className="w-25"
                            />
                          </div>
                          <div className="qrPript">
                            <QRCode
                              bgColor="#FFFFFF"
                              fgColor="#000000"
                              level="H"
                              value={
                                props.auth?.user?.VendorUser?.shareLink
                                  ?.userShortLink || " "
                              }
                            />
                          </div>
                          <div className="print-12-400-r text-uppercase">
                            <span className="print-border-bottom">
                              {props.onboarding &&
                                props.onboarding.restaurant_name}
                            </span>
                          </div>
                          <div className="print-12-400-r text-uppercase">
                            <span className="print-border-bottom print-hide-text">
                              {props.onboarding &&
                                props.onboarding.restaurant_name}
                            </span>
                          </div>
                          <div className="print-12-400-h">
                            Scan via Amealio App
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="py-4 d-flex justify-content-center align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 btn150px"
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5 btn150px"
                        onClick={printQrCodeAction}
                      >
                        Print
                      </Button>
                    </div>
                  </React.Fragment>
                )}
              </Col>
            </Row>
          </div>
        </Row>
      </Container>
    </React.Fragment>
  );
};
// export default Referrealcodeview;

Referrealcodeview.propTypes = {
  auth: PropTypes.object.isRequired,
  onboarding: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, null)(withRouter(Referrealcodeview));
